import { Box, Button } from "@mui/material"
import SummaryTable from "./SummaryTable"
import * as XLSX from "xlsx"
// import { summaryData } from "./static"
import { useAppSelector } from "../../../util/hooks"
// import { useNavigate } from "react-router-dom"
// import { SCREENS_DETAILS } from "../../../util/StaticData"
// import { setSaveClicked } from "../mapping/MapSlice"
import { toast } from "react-toastify"
// import DownloadDropdown from "../../Quality/DownloadDropdown"
import AddToPipelineModal from "../../../components/Harmonization/AddToPipelineModal"
import { useState } from "react"
import DownloadOutlinedIcon from "@mui/icons-material/DownloadOutlined"

const MappingSummary = () => {
  // const navigate = useNavigate()
  // const dispatch = useAppDispatch()
  const [isOpen, setIsOpen] = useState(false)
  const mappedData = useAppSelector((state) => state.map.mappedData)
  // const absoluteMappedCount = mappedData.filter(
  //   (data) => data.status === 1,
  // ).length

  // const mappingAccuracy = (absoluteMappedCount / mappedData.length) * 100

  // useEffect(() => {
  //   dispatch(setMappingAccuracy(mappingAccuracy))
  // }, [mappedData])

  // const mappingAccuracy =
  //   mappedData.reduce(
  //     (total, data) => total + parseInt(data.mapping_accuracy.replace("%", "")),
  //     0,
  //   ) / mappedData.length

  // const handleSave = () => {
  //   toast.success("Your data mapping has been successfully saved", {
  //     position: "top-right",
  //     autoClose: 1000,
  //     hideProgressBar: false,
  //     closeOnClick: true,
  //     pauseOnHover: true,
  //     draggable: true,
  //     progress: undefined,
  //     progressStyle: { backgroundColor: "#2FD4CF" },
  //     onClose: () => {
  //       dispatch(setSaveClicked(true))
  //       navigate("/" + SCREENS_DETAILS.DATA_HARMONIZATION)
  //     },
  //   })
  // }

  // const handleDownloads = (option: string) => {
  //   const wb = XLSX.utils.book_new()

  //   let dataToExport: any[] = []
  //   if (option === "Mapped Dataset") {
  //     const excluded = new Set(["id", "status", "similarity", "approval_status", "match_status"])
  //     const rows = mappedData.map((row: any) => {
  //       const obj: any = {}
  //       Object.keys(row).forEach((k) => {
  //         if (!excluded.has(k)) {
  //           obj[k] = row[k]
  //         }
  //       })
  //       return obj
  //     })
  //     dataToExport = rows
  //   } else {
  //     dataToExport = summaryData
  //   }

  //   const ws = XLSX.utils.json_to_sheet(dataToExport)

  //   XLSX.utils.book_append_sheet(wb, ws, "Sheet1")

  //   XLSX.writeFile(wb, option === "Mapped Dataset" ? "Mapped_Dataset.xlsx" : "Mapping_Rules.xlsx")
  // }

  function mapField(key: string, value: any): any {
    if (key === "similarity" && typeof value === "number") {
      return `${(value * 100).toFixed(2)}%`
    }

    if (key === "status") {
      switch (value) {
        case 1:
          return "Absolute Mapped"
        case 2:
          return "Approximate Mapped"
        case 3:
          return "Not Mapped"
        default:
          return value // fallback for unexpected status values
      }
    }

    return value
  }

  const handleDownloadButton = () => {
    const wb = XLSX.utils.book_new()

    let dataToExport: any[] = []
    const sortedData = [...mappedData].sort(
      (a, b) => (b.similarity ?? 0) - (a.similarity ?? 0),
    )
    const excluded = new Set(["id", "approval_status", "match_status"])

    const rows = sortedData.map((row: any) => {
      const obj: any = {}

      Object.entries(row).forEach(([key, value]) => {
        if (!excluded.has(key)) {
          obj[key] = mapField(key, value)
        }
      })

      return obj
    })

    dataToExport = rows

    const ws = XLSX.utils.json_to_sheet(dataToExport)

    XLSX.utils.book_append_sheet(wb, ws, "Sheet1")

    XLSX.writeFile(wb, "Mapped_Dataset.xlsx")
  }

  const handleDeployToPipeline = (res: string) => {
    if (res === "cancel") {
      setIsOpen(false)
      return
    }

    toast.success(
      "Deployment successful! Your Mapping file is saved and applied to the pipeline",
      {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        progressStyle: { backgroundColor: "#2FD4CF" },
      },
    )

    setIsOpen(false)
  }

  return (
    <div className="flex flex-col gap-5">
      <div className="flex justify-between">
        <p className="text-xl font-bold">Mapping Summary</p>

        <Box sx={{ display: "flex", gap: 2 }}>
          {/* <DownloadDropdown
            options={["Mapped Dataset", "Mapping Rules"]}
            onOptionClick={handleDownloads}
          /> */}

          <Button
            onClick={handleDownloadButton}
            style={{
              width: "fit-content",
              alignSelf: "end",
            }}
            sx={{
              backgroundColor: "primary.main",
              gap: 1,
              fontWeight: 600,
              fontSize: 11,
              color: "#ffffff",
              textTransform: "none",
              borderRadius: "6px",
              px: 1,
              transition: "all 0.3s ease",
              boxShadow: 0,
            }}
            variant="contained"
            size="small"
            endIcon={<DownloadOutlinedIcon />}
          >
            Download
          </Button>

          <Button
            onClick={() => setIsOpen(true)}
            style={{
              width: "fit-content",
              alignSelf: "end",
            }}
            sx={{
              backgroundColor: "primary.main",
              gap: 1,
              fontWeight: 600,
              fontSize: 11,
              color: "#ffffff",
              textTransform: "none",
              borderRadius: "6px",
              px: 1,
              transition: "all 0.3s ease",
              boxShadow: 0,
            }}
            variant="contained"
            size="small"
          >
            Deploy to Pipeline
          </Button>

          {/* <Button
            onClick={handleSave}
            style={{
              width: "fit-content",
              alignSelf: "end",
            }}
            sx={{
              backgroundColor: "primary.main",
              gap: 1,
              fontWeight: 600,
              fontSize: 11,
              color: "#ffffff",
              textTransform: "none",
              borderRadius: "6px",
              px: 1,
              transition: "all 0.3s ease",
              boxShadow: 0,
            }}
            variant="contained"
            size="small"
          >
            Save Scenario
          </Button> */}
        </Box>
      </div>

      {/* <Box
        sx={{ backgroundColor: "tableColors.header" }}
        className="flex justify-between max-w-[436px] p-4 rounded-lg"
      >
        <div className="flex gap-1 items-center">
          <TargetBoardIcon />
          <p className="text-sm font-bold">MAPPING ACCURACY</p>
        </div>

        <p className="text-xl font-medium">
          {Math.round(mappingAccuracy)}%{" "}
          <span className="text-xs">
            ({absoluteMappedCount + " out of " + mappedData.length})
          </span>
        </p>
      </Box> */}

      <SummaryTable />
      <AddToPipelineModal
        isOpen={isOpen}
        title={"What would you like to do?"}
        onClick={handleDeployToPipeline}
      />
    </div>
  )
}

export default MappingSummary
